import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallLog } from '@/models/callLog';

export const fetchCustomerLiveCallLog = async (phoneNumber: string): Promise<CallLog | null> => {
  const response = await queryExecute({
    query: graphql(`
      query CustomerLiveCallLog($phoneNumber: String!) {
        customerLiveCallLog(phoneNumber: $phoneNumber) {
          id
        }
      }
    `),
    variables: {
      phoneNumber,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.customerLiveCallLog ?? null;
};
